import React from 'react';
import { Link } from 'react-router-dom';

const AboutMain = ({ lang, personalInfo }) => {

  if (!personalInfo) return <div>No info found</div>;

  const { description } = personalInfo;

  return (
    <div className="about__content-main">
      <h3 className="about__content-title">
        {lang === 'en' ? 'Get to know me!' : '¡Conóceme!'}
      </h3>
      <div className="about__content-details">
        <p className="about__content-details-para">{description}</p>
      </div>
      <Link to="/about" className="btn btn--med btn--theme dynamicBgClr">
        {lang === 'en' ? 'Learn More' : 'Saber Más'}
      </Link>
    </div>
  );
};

export default AboutMain;